import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "lib-footer",
  template: `
    <footer>
      <ng-content></ng-content>
    </footer>
  `,
  styleUrls: ["./footer.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class FooterComponent {}
